import React from "react";

import DadosGeraisPropostaSection from "../sections/DadosGeraisPropostaSection";
import DadosOperacaoSection from "../sections/DadosOperacaoSection";
import AgregadosSection from "../sections/AgregadosSection";
import LojistaShortSection from "../sections/LojistaShortSection";
import {
  ComponentWrapper,
  CardWrapper,
  Label,
  CardFilled,
  Card,
} from "../styles";

const OperationComponent = (props) => {
  const {
    proposalOperation = {},
    proposalOperationLoading,
    proposalInfoWarranty = {},
    proposalInfoWarrantyLoading,
    proposalWarrantyVehicleInfo = {},
    aggregates = [],
    aggregatesLoading,
    operationTotalValue,
    proposalCompleteRegistration = {},
    proposalCompleteRegistrationLoading,
    paymentTypes = {},
    paymentTypesLoading,
  } = props;

  return (
    <ComponentWrapper>
      <CardWrapper>
        <Label>Dados gerais da proposta</Label>
        <CardFilled>
          <DadosGeraisPropostaSection
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            proposalOperationLoading={proposalOperationLoading}
            numeroCpfCnpj={proposalCompleteRegistration.cpfCnpj}
            nomeCliente={proposalCompleteRegistration.nomeCliente}
            tipoPessoa={proposalCompleteRegistration.tipoPessoa}
            nomeConvenio={proposalCompleteRegistration.nomeConvenio}
            nomeFilial={proposalCompleteRegistration.nomeFilial}
            nomeFilialFantasia={proposalCompleteRegistration.nomeFilialFantasia}
            numeroProposta={proposalOperation.numeroProposta}
            produto={proposalOperation.produto}
            nomeAnalista={proposalCompleteRegistration.nomeAnalista}
            descricaoStatus={proposalCompleteRegistration.descricaoStatus}
            rankingRelacionamento={
              proposalCompleteRegistration.rankingRelacionamento
            }
            sistemaOrigem={proposalCompleteRegistration.sistemaOrigem}
            pcLtvRisco={proposalCompleteRegistration.pcLtvRisco}
            pcCompRendaCliente={proposalCompleteRegistration.pcCompRendaCliente}
            idRiscoScrCliente={proposalCompleteRegistration.idRiscoScrCliente}
            idRiscoSerasaCliente={
              proposalCompleteRegistration.idRiscoSerasaCliente
            }
          />
        </CardFilled>
      </CardWrapper>

      <CardWrapper>
        <Label>Dados da operação</Label>
        <Card>
          <DadosOperacaoSection
            proposalOperationLoading={proposalOperationLoading}
            proposalInfoWarrantyLoading={proposalInfoWarrantyLoading}
            valorTotalFinanciado={proposalOperation.valorTotalFinanciado}
            valorProposta={proposalOperation.valorProposta}
            retorno={proposalOperation.retorno}
            valorEntrada={proposalOperation.valorEntrada}
            quantidadePrestacoes={proposalOperation.quantidadePrestacoes}
            valorPrestacao={proposalOperation.valorPrestacao}
            valorLiquido={proposalOperation.valorLiquido}
            valorContrato={proposalOperation.valorContrato}
            valorIof={proposalOperation.valorIof}
            dataVencimentoPrimeiraPrestacao={
              proposalOperation.dataVencimentoPrimeiraPrestacao
            }
            dataVencimentoUltimaPrestacao={
              proposalOperation.dataVencimentoUltimaPrestacao
            }
            taxaMes={proposalOperation.taxaMes}
            taxaAA={proposalOperation.taxaAA}
            cetAm={proposalOperation.cetAm}
            cetAA={proposalOperation.cetAA}
            valorTac={proposalOperation.valorTac}
            valorSeguro={proposalOperation.valorSeguro}
            valorOutros={proposalOperation.valorOutros}
            valorMercado={proposalInfoWarranty.valorMercado}
            produto={proposalOperation.produto}
            operationTotalValue={operationTotalValue}
            valorVenda={proposalWarrantyVehicleInfo?.veiculo}
            sistemaOrigem={proposalCompleteRegistration.sistemaOrigem}
            paymentTypes={paymentTypes}
            paymentTypesLoading={paymentTypesLoading}
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            dadosAdicionais={proposalCompleteRegistration}
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Agregados</Label>
        <Card>
          <AgregadosSection
            aggregatesLoading={aggregatesLoading}
            aggregates={aggregates}
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Lojista</Label>
        <Card>
          <LojistaShortSection
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            nomeAgente={proposalCompleteRegistration.nomeAgente}
            ratingFilial={proposalCompleteRegistration.ratingFilial}
            ufFilial={proposalCompleteRegistration.ufFilial}
          />
        </Card>
      </CardWrapper>
    </ComponentWrapper>
  );
};

export default OperationComponent;
